"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _constructedForm = _interopRequireDefault(require("../styles/constructed-form.css"));
var _errorMessage = _interopRequireDefault(require("./error-message"));
var _constructedForm2 = _interopRequireDefault(require("./constructed-form.props/constructed-form.defaultProps"));
var _constructedForm3 = _interopRequireDefault(require("./constructed-form.props/constructed-form.propTypes"));
/**
 * ## RadioButtons - component
 *
 * Some really cool piece of description goes here.
 */
// We use the same default props for data and defaultData
// This keeps our PropTypes and DefaultProps objects nice and clean and non repeating
var RadioButtons = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(RadioButtons, _React$Component);
  // All components need a resourceType in order for AEM to be aware of its existance
  RadioButtons.resourceType = function resourceType() {
    return 'ChoiceType_1_0_0';
  };
  function RadioButtons(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = RadioButtons.prototype;
  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var _this$props = this.props,
      value = _this$props.value,
      errorMessages = _this$props.errorMessages;
    return nextProps.value[0] !== value[0] || nextProps.errorMessages[0] !== errorMessages[0];
  };
  _proto.handleChange = function handleChange(idx, fieldName) {
    var _this2 = this;
    // We pass the value in as an array value because some inputs like radio may be multi-select
    return function (e) {
      var _this2$props = _this2.props,
        value = _this2$props.value,
        handleFieldBlur = _this2$props.handleFieldBlur,
        handleFieldChange = _this2$props.handleFieldChange,
        checkRequired = _this2$props.checkRequired,
        data = _this2$props.data,
        updateErrors = _this2$props.updateErrors;
      if (!value || value.length === 0) {
        var required = checkRequired(e.target.value, data.isRequired);
        updateErrors(idx, [required]);
      }
      handleFieldChange(idx, [e.target.value], fieldName);
      if (handleFieldBlur) {
        handleFieldBlur(e.target.value, idx, ['', '']);
      }
    };
  };
  _proto.render = function render() {
    var _this3 = this;
    var _this$props2 = this.props,
      propValue = _this$props2.value,
      theme = _this$props2.theme,
      _this$props2$errorMes = _this$props2.errorMessages,
      errorMessages = _this$props2$errorMes === void 0 ? [''] : _this$props2$errorMes,
      id = _this$props2.id,
      _this$props2$data = _this$props2.data,
      fieldName = _this$props2$data.fieldName,
      fieldLabel = _this$props2$data.fieldLabel,
      requiredMessage = _this$props2$data.requiredMessage,
      options = _this$props2$data.options,
      choiceFieldType = _this$props2$data.choiceFieldType,
      isRequired = _this$props2$data.isRequired;
    var value = propValue[0];
    var errors = errorMessages.filter(function (error) {
      return error !== '';
    });
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _constructedForm["default"].formField,
      key: fieldName
    }, /*#__PURE__*/_react["default"].createElement("fieldset", {
      className: _constructedForm["default"].optionSet,
      "aria-describedby": errors.length !== 0 && fieldName + "-error-" + id.join('-')
    }, /*#__PURE__*/_react["default"].createElement("legend", {
      className: _constructedForm["default"].fieldLabel + " " + theme.labelSmall
    }, fieldLabel && fieldLabel.trim(), isRequired && /*#__PURE__*/_react["default"].createElement("span", {
      className: _constructedForm["default"].requiredNotification
    }, "*")), options && options.map(function (option) {
      // eslint-disable-next-line
      var inputId = Math.floor(Math.random() * 999);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _constructedForm["default"].optionField,
        key: fieldName + "-" + option.key
      }, /*#__PURE__*/_react["default"].createElement("input", {
        className: "" + _constructedForm["default"].optionInput,
        type: choiceFieldType,
        name: fieldName + "-" + option.key,
        id: fieldName + "-" + option.key + "-" + inputId,
        checked: value === option.key,
        value: option.key,
        disabled: option.disabled,
        onChange: _this3.handleChange(id, fieldName)
      }), /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: fieldName + "-" + option.key + "-" + inputId,
        className: theme.inputsAndOptions + " " + _constructedForm["default"].optionLabel
      }, option.label));
    }), errorMessages[0] === 'requiredMessage' ? /*#__PURE__*/_react["default"].createElement(_errorMessage["default"], {
      message: requiredMessage,
      theme: theme,
      errorLabel: fieldName + "-error-" + id.join('-'),
      role: "alert"
    }) : errorMessages.map(function (message, i) {
      return /*#__PURE__*/_react["default"].createElement(_errorMessage["default"], {
        key: i,
        message: message,
        theme: theme,
        errorLabel: fieldName + "-error-" + id.join('-'),
        role: "alert"
      });
    })));
  };
  return RadioButtons;
}(_react["default"].Component);
exports["default"] = RadioButtons;
RadioButtons.displayName = 'RadioButtons';
RadioButtons.defaultProps = {
  data: _constructedForm2["default"].formComponents[1],
  theme: {}
};